<div class="grid-module">
  <div class="cell-navigation">
    <cst-toolbar>
      <h3>
        <a [routerLink]="['/administration']" i18n="@@Admin_Header"
          >Administration</a
          >
          @if (displayModuleInHeader) {
            > <a [routerLink]="['..']">{{ module }}</a>
          }
          > {{ header }}
        </h3>
        @if (appAdminModulePageToolbar) {
          <div style="margin-left: 2em;">
            <ng-container [ngTemplateOutlet]="appAdminModulePageToolbar.tpl">
            </ng-container>
          </div>
        }
      </cst-toolbar>
    </div>
    <div class="cell-content">
      <ng-content></ng-content>
    </div>
  </div>
